import { ReportEntry } from '../../../../../../domain/report/ReportEntry';

export const reportCase = (reportEntry: ReportEntry): string => reportEntry.case;
